module.exports = __webpack_public_path__ + "img/EllipseGold.06ea3c48.svg";